<template>
    <div class="album-content">
        <div class="p-bottom-20">
            <a-select class="width-160 m-right-20" v-model="klassId" placeholder="请选择班级" @change="klassChange">
                <a-select-option v-for="item in klassList" :value="item.id" :key="item.id">
                    {{ item.name }}
                </a-select-option>
            </a-select>
        </div>
        <a-table :columns="tempColumns" :data-source="albumTempList"
            :rowKey="(record, index) => `${index}_${record.id}`" :pagination="false" bordered>
            <template slot="operation" slot-scope="text, record">
                <div class="album-table_btn">

                    <a class="album-table_btn m-left-20" href="javascript:;" @click="viewAlbum(record)">
                        <svg-icon iconClass="edit"></svg-icon>
                        <span class="album-table_btn_text">编辑</span>
                    </a>

                    <a class="album-table_btn m-left-20" href="javascript:;" @click="copyHandle(record)">
                        <svg-icon iconClass="copy"></svg-icon>
                        <span class="album-table_btn_text">复制</span>
                    </a>

                    <!-- <a class="album-table_btn m-left-20" href="javascript:;" @click="updateStatusHandle(record)">
                        <svg-icon iconClass="forbidden"></svg-icon>
                        <span class="album-table_btn_text">{{ record.is_active ? "禁用" : "激活" }}</span>
                    </a> -->

                    <a class="album-table_btn del-color m-left-20" href="javascript:;" @click="delHandle(record)">
                        <svg-icon iconClass="delete"></svg-icon>
                        <span class="album-table_btn_text">删除</span>
                    </a>
                </div>
            </template>
            <template slot="albumName" slot-scope="albumName, record">
              <span  v-if="record.id">
                <a v-if="!record.editable" href="javascript:;" @click="viewAlbum(record)">{{ albumName }} <svg-icon @click.stop.prevent="editName(record)" class="m-left-10" iconClass="edit"></svg-icon></a>
                <a v-else href="javascript:;" class="album-table_input">
                  <a-input v-model="record.value" placeholder="请输入模板名称"/>
                  <a-icon class="m-left-10" type="close" @click="cancelHandle(record)" />
                  <a-icon class="m-left-10" type="check" @click="submitName(record)" />
                </a>
              </span>
              <span v-else>暂无手册</span>
            </template>
        </a-table>
    </div>
</template>
  
<script>
import { mapGetters } from "vuex"
import AlbumTempService from "@/api/albumTempService"
import { getAlbumTempColumns } from "./constant"
import { isNumber } from "@/utils/number"
import albumMixins from "./albumMixins"

export default {
  name: "AlbumTemp",
  mixins: [albumMixins],
  data() {
    return {
      tempColumns: getAlbumTempColumns(),
      albumTempList: [],
      loading: false,
      klassId: undefined
    }
  },

  computed: {
    ...mapGetters(["klassList"])
  },

  created() {
    this.initHandle()
  },

  methods: {
    initHandle() {
      if (!this.klassList.length) {
        setTimeout(() => {
          this.initHandle()
        }, 200)
        return
      }
      this.klassId = this.$route.query.klass_id || this.klassList[0].id
      this.klassChange()
    },

    klassChange() {
      this.$router.replace({
        name: "album",
        query: { ...this.$route.query, klass_id: this.klassId }
      })
      this.getAlbumTempList()
    },
    getAlbumTempList() {
      AlbumTempService.getAlbumTempListService({
        klass_id: this.klassId
      }).then((res = []) => {
        this.albumTempList = res.map(item => {
          item.editable = false
          item.value = item.title
          return item
        })
      })
    },

    delHandle(record) {
      this.$confirm({
        title: "提示信息",
        content: `是否删除当前手册模板 ${record.title}`,
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise((resolve, reject) => {
            AlbumTempService.updateAlbumTempStatusService({
              tempId: record.id
            })
              .then(() => {
                this.$message.success("操作成功")
                this.getAlbumTempList()
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    copyHandle(record) {
      this.$confirm({
        title: "提示信息",
        content: `是否复制当前手册模板 ${record.title}`,
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise((resolve, reject) => {
            AlbumTempService.createAlbumTempService({ title: this.getFileName(record.title), pages: this.getAlbumTempBody(record.page_views), klass_id: this.klassId })
              .then(() => {
                this.$message.success("操作成功")
                this.getAlbumTempList()
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },
    // getAlbumTempBody(record) {
    //   const pageViews = []
    //   for (let i = 0; i < record.page_views.length; i++) {
    //     const { background_image, section_views, ...others } = record.page_views[i]
    //     for (let j = 0; j < section_views.length; j++) {
    //       section_views[j].field_views.map(item => {
    //         if (item.default_image) {
    //           item.default_image_id = item.default_image.id
    //           delete item.default_image
    //         }
    //       })
    //       section_views[j].fields = section_views[j].field_views
    //       delete section_views[j].field_views
    //     }
    //     pageViews.push({
    //       background_image_id: background_image.id,
    //       sections: section_views,
    //       ...others
    //     })
    //   }

    //   return { title: this.getFileName(record.title), pages: pageViews, klass_id: this.klassId }
    // },

    viewAlbum(album) {
      this.$router.push({
        name: "albumTempDetail",
        query: { id: album.id, klass_id: this.klassId }
      })
    },

    editName(record) {
      record.editable = true;
      record.value = record.title
    },

    submitName(record) {
      if (!record.value || !record.value.trim().length) {
        this.$message.warning("请输入模板名称")
        return
      }

      AlbumTempService.updateAlbumTempService({ tempId: record.id, title: record.value.trim(), pages: this.getAlbumTempBody(record.page_views) })
        .then(() => {
          this.$message.success("修改成功")
          record.editable = false
          record.title = record.value.trim();
        })
        .catch(() => {
          this.$message.error("操作失败，请重新操作")
        })
    },

    cancelHandle(record) {
      record.value = record.title
      record.editable = false
    },

    getFileName(title) {
      let _title = title.indexOf("副本") > -1 ? title : `${title}-副本`
      let num = 0

      if (isNumber(_title.substr(-1))) {
        _title = _title.substr(0, _title.length - 1)
        num = +_title.substr(-1)
      }

      for (let i = 0; i < this.albumTempList.length; i++) {
        const item = this.albumTempList[i]

        if (item.title.indexOf(_title) == -1) continue

        if (!isNumber(item.title.substr(-1))) {
          num = num || 1
          continue
        }

        num = Math.max(num, +item.title.substr(-1) + 1)
      }

      return num ? `${_title}${num}` : _title
    }
  }
}
</script>
  
<style lang="less" scoped>
.album {
  &-container {
    background: #ffffff;
    min-height: calc(100% - 65px);
    margin-top: 15px;

    /deep/.ant-tabs-nav-scroll {
      background: #f0f2f5;
    }

    /deep/.ant-tabs-tab {
      border: none !important;
      margin: 0 !important;
    }

    /deep/.ant-tabs-bar {
      margin-bottom: 0;
    }
  }

  &-content {
    padding: 28px 28px 2px 30px;
  }

  &-table {
    &_btn {
      display: flex;
      flex-flow: nowrap row;
      align-items: center;
      justify-content: center;
      line-height: 1;

      &_text {
        margin-left: 5px;
        line-height: 1;
      }

      &_disabled {
        cursor: not-allowed;
        color: rgba(0, 0, 0, 0.25);
        border-color: #d9d9d9;
      }
    }

    &_input {
      display: flex;
      flex-flow: nowrap row;
      align-items: center;
    }
  }
}
</style>
